(function() {
  /*
	|--------------------------------------------------------------------------
	| AJAX INTERACTIONS
	|--------------------------------------------------------------------------
	*/
  var performAjaxRequest = function(url, options, callback) {
    options._token = _csrf;
    $.ajax({
      url: url,
      data: options,
      type: "POST",
      dataType: "html",
      success: function(data) {
        callback(data);
      },
      error: function(xhr, status) {
        alertAjaxError();
      }
    });
  };

  var getCoursesList = function(classroomId) {
    var options = {};
    options.classroomId = classroomId;
    var url = "/ajax/getcourseslist";
    performAjaxRequest(url, options, setCoursesList);
  };

  var setCoursesList = function(data) {
    var $el = $("#course_id")
      .prop("disabled", false)
      .empty()
      .append($("<option></option>").attr("value", 0).text("---"));
    $.each(JSON.parse(data), function(value, key) {
      $el.append(
        $("<option></option>")
          .attr("value", value)
          .text(key)
      );
    });
  };

  var getSchoolsList = function() {
    var options = {};
    var url = "/ajax/getschoolslist";
    performAjaxRequest(url, options, setSchoolsList);
  };

  var setSchoolsList = function(data) {
    var $el = $("#school_id")
      .empty()
      .append(
        $("<option></option>")
          .attr("value", 0)
          .text("---")
      );
    $.each(JSON.parse(data), function(value, key) {
      $el.append(
        $("<option></option>")
          .attr("value", value)
          .text(key)
      );
    });
  };

  var getClassroomsList = function(schoolId) {
    var options = {};
    options.schoolId = schoolId;
    var url = "/ajax/getclassroomslist";
    performAjaxRequest(url, options, setClassroomsList);
  };

  var setClassroomsList = function(data) {
    var $el = $("#classroom_id")
      .prop("disabled", false)
      .empty(); // remove old options

    $el.append(
      $("<option></option>")
        .attr("value", 0)
        .text("---")
    );

    $.each(JSON.parse(data), function(value, key) {
      $el.append(
        $("<option></option>")
          .attr("value", value)
          .text(key)
      );
    });
  };

  /*
	 |--------------------------------------------------------------------------
	 | SIMPLE CLIENT SIDE VALIDATION
	 |--------------------------------------------------------------------------
	 */
  String.prototype.isEmpty = function() {
    return this.length === 0 || !this.trim() || this.trim() == 0;
  };

  var validateForm = function() {
    var error = false;
    var form = $("#registerForm");

    var fieldsToCheck = {
      Nome: form.find("#name").val(),
      Cognome: form.find("#surname").val(),
      Email: form.find("#email").val(),
      Password: form.find("#password").val()
    };

    var flag = $("input[name='flag']")
      .parent('[class*="icheckbox"]')
      .hasClass("checked");
    if (!flag) {
      sweetAlert(
        "E' necessario accettare la Privacy Policy e Termini e Condizioni",
        "",
        "error"
      );
      error = true;
      return !error;
    }

    $.each(fieldsToCheck, function(key, value) {
      if (value.isEmpty()) {
        sweetAlert("Il campo " + key + " e' obbligatorio", "", "error");
        error = true;
        return !error;
      }
    });

    return !error;
  };

  $("#btnRegister").click(function(e) {
    e.preventDefault();
    var validationPassed = validateForm();
    console.log(validationPassed);
    if (validationPassed) {
      $("#registerForm").submit();
    }
  });

  /*
	|--------------------------------------------------------------------------
	| ACCESSORIES FUNCTIONS
	|--------------------------------------------------------------------------
	*/
  var alertAjaxError = function() {
    swal("Si è verificato un errore nel caricamento dei dati.", "", "error");
  };

  /*
  |--------------------------------------------------------------------------
  | LISTENERS
  |--------------------------------------------------------------------------
  */
  $("#school_id").change(function(e) {
    e.preventDefault();
    $("#classroom_id").empty().prop("disabled", "disabled");
    getClassroomsList($(this).find(":selected").val());
  });

  $('#classroom_id').change(function (e) {
    e.preventDefault();
    $("#course_id").empty().prop('disabled', 'disabled');
    getCoursesList($(this).find(":selected").val());
  });

  $("#submitButton").click(function(e) {
    e.preventDefault();
    var validationPassed = validateForm();
    if (validationPassed) {
      $("#registrationForm").submit();
    }
  });
  getSchoolsList();
})();
